var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.6 300.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c2c58;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#fff;}.cls-3{fill:#d1a782;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "glasses") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.53,158.46c.77-2,3.77-3.42,4.69-6,.77-2.13.55-4.6,1.28-6.4,2.33-5.7,7.5-11.54,11.53-16.64,8.41-10.67,17.23-25.51,20-41,4.42-24.21-4-48.87-8.54-73.81C82.11,8.59,64.18,7.45,46.61,8.28,33,8.92,19,9.42,8.64,12.54,5.08,29.27,1,47.48.11,65.87-.8,85.35,4.2,102.4,12.48,115.37c9,14,22.83,21.26,30.29,35a477.28,477.28,0,0,1,5.12,56.33c.75,20.07,1.56,41,1.28,59.3-12.35,2.59-34.82,1.61-36.27,14.08-.79,6.85,6.69,14.66,12,17.07,9.78,4.48,41.66,4,56.32,0,5.31-1.44,11.17-4.88,13.66-8.11,7.43-9.64.38-16.8-8.54-19.63-7.38-2.33-15.88-.39-23.47-2.13-1.52-26-2.59-55.59-.42-82.35C63.09,176.37,62,165.15,64.53,158.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.44,15.53C67.12,23,35.3,22.12,14.19,17.66,18,14.79,24.31,14.44,30,13.82,47.45,11.92,70,10.51,85.44,15.53Zm-50.35-.85c-3.76.29-7.93-.42-10.24,2.13,13.58-1.29,27.95-.15,41.39-.86C58,13.89,45.12,13.9,35.09,14.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.28,20.22h.85c2.28,12.52,4.44,25.15,5.12,39.26C70.09,53.6,33,54,6.5,57.77,7.9,45.66,9.84,34.08,10.77,21.5c10.15,2.89,23.67,6.68,40.53,5.55C65.41,26.1,81,23.7,89.28,20.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.68,63.31c-3.05,3-8.51,3.48-13.23,4.27C73,69.17,60.78,69.66,49.6,69.72c-15,.08-30.51-1.8-40.54-6.41,9.55-5.24,24.53-4.45,38.83-5.11C65.31,57.39,84.24,57.06,95.68,63.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.53,144.81c.85,1.36-2.53,5.66-3.41,8.11-2.86,1.88-6.95,3.43-11.09,1.7a36.63,36.63,0,0,1-2.57-7.25C53.61,149.31,60.44,147.43,64.53,144.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.41,160.17c.36-.08.4.17.43.43a700.74,700.74,0,0,0-1.28,99c.12,2.07.4,4.68.43,6.83,0,1.9.86,4.82-1.29,6-5.22-.22-3.62-7.24-3.83-10.24C53,249.87,53,235.64,53,221.61c0-21.29-2.07-42.17-3-61C53,160.71,57.17,161.78,59.41,160.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.6,271.1c.08,5.57,10.2,9,11.94,2.14,2.89,2.38,4.57,5.95,9,6.82-7.45,3.93-22.35,5.26-32.42,2.56-1.89.07.2-1.2-.86-1.71-2.82-.4-4.34.49-5.11,2.14,2.58.69,3.34,3.19,6.39,3.41-1.52,1.49-4.42-1-6,.43.1.75.73,1,1.71.85-4.37,1.1-10.28.05-13.66-1.28-2.31-5.84,5.37-8.81,10.25-10.66,5-1.92,10.25-3.06,13.65-4.27-2.7,3.7-7.49,5.31-11.1,8.11C41.34,281,46,275.44,49.6,271.1ZM23.14,282.62c1.32.79,4.69.6,4.7-1.27C25.82,281.32,23.79,281.28,23.14,282.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.16,274.52c1.34-.21,1.13,1.14,2.13,1.28a34.28,34.28,0,0,1-5.12,3C81.35,276.54,83.63,276.4,84.16,274.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.37,285.61a13.73,13.73,0,0,1-6.83,1.28C63.53,286.18,66.34,285,68.37,285.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.42,293.29c11.61,1,27.14,3.72,41.39,2.13C53.68,297.47,33.84,298,24.42,293.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.31,110.68c-.54,3.17-4.51,6.58-6.83,9.38-7.2,3.56-15.94,7.07-26,6.4-9.83-.65-18.78-4.67-25.6-7.68C13.54,106.62,4.74,92,6.08,67.15c23.81,8,64.53,8.65,88.75.43,2,18.77-6.48,30.79-14.94,40.54-8.25,2.95-14.6,7.92-23.89,9C27.09,120.31,12.87,99.82,8.21,77.39c-1.35,14.14,6.51,27.22,15.36,34.14,8.06,6.29,20.66,10.45,34.13,9,4.83-.54,9.77-2.69,14.51-4.27,2.23-.59-1.89,1.19-1.28,3C74.48,117.49,78.87,112.93,83.31,110.68ZM40.21,76.54c8.61,3.28,26.34,2.23,34.13-.85C63.17,75.9,50.85,77.22,40.21,76.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.13,123.05c3,1.11,5.81,2.44,9,3.41-.54,1.17-1.71,1.7-2.56,2.56C30.18,127.24,27.38,125.93,26.13,123.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.21,125.18c-4.63,3.33-7.54,8.39-13.65,10.24C62.89,131.79,66.34,127.27,72.21,125.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.08,127.31c.76,0,.9.53,1.7.43-1.08,1.6-2.34,4.38-4.69,3.42C35.59,129.38,37.87,129.38,38.08,127.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.91,129c-2.11,1.24-3.57,5.16-6.41,4.27C39.87,131.21,42,128.17,44.91,129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.4,128.6c.34,2.34-5.91,4-5.12,6.82-.9,1.09-3.15.84-5.12.86C55.31,133.45,58.11,130.28,62.4,128.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.73,129.45c-2.51,2.32-3.87,5.8-8.53,6A9.72,9.72,0,0,1,51.73,129.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.85,129.45c-2.66,2.46-4.49,5.75-8.53,6.83C50.69,133.53,53,130.67,56.85,129.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.66,133.29c-.59-.78.82-1.28,1.29-1.71C70.74,129,69.64,131,66.66,133.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.33,138.84c6.15.35,15.11.52,20.48-2.14.87.91-4.4,3.8-7.25,4.27C53.93,141.73,47.56,141.34,45.33,138.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.76,275.8c.42-.55-2.31,2.68-4.27,2.56C74.31,276.9,76.05,276.36,77.76,275.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.16,279.64c.72,2-3,3.24-5.12,3.84C79.13,282.27,83,281.16,84.16,279.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.33,281.35c-.31,2.25-5.19,3.62-8.53,4.26C71,283.55,75.05,283.33,77.33,281.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.32,292.86c-.83.88-2.6.82-3.84,1.28C74.67,293.77,79.21,293.09,80.32,292.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.4,137.4c7.17,7.47,14.25,15.91,17.64,26.46,8.88,27.57,4.35,60.46,7.56,97-12.76.52-24.56,1.23-34,5-3.69,1.49-11.28,6.13-11.76,11.76-.85,9.77,10.76,14.59,20.57,17.64,20.15,6.27,47.8,6.73,68.88.84,8.59-2.39,21.9-8,19.74-18.89-1.35-6.8-13.26-10-20.58-11.76a170.09,170.09,0,0,0-28.13-4.21c-.44-13.62-.85-29.11-.85-44.93,0-15.26-.83-31.29,2.1-44.1,4.2-18.36,16.69-32.49,29-46.2a105.24,105.24,0,0,0,15.12-22.26c4.62-8.94,8.95-17.45,9.66-28.14.78-11.54,0-21.1-3.36-30.24-1.1-3-3.8-6.39-5.88-10.5-1.83-3.62-3.35-7.67-5.46-10.92-3.56-5.52-9.46-14.64-15.12-17.64C230.89.74,213.43-.29,197.4.06,185.9.31,175.21,3,165.49,5.94c-12.55,14.39-22,31.44-25.2,53.76-3.35,23.44,7.4,39.46,16.79,53.34A181.78,181.78,0,0,0,176.4,137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.32,9.72c-18.17-.29-32.06.16-49.14-1.26C191.89,5.32,217.48,6.1,229.32,9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231,14.76c-11.84,3.14-27.58,2.37-42.41,2.52,3.27,2.22,8.33,1.26,13,1.26,12.71,0,28.2.35,35.28-5,10.84,4.69,16.76,14.81,22.68,26.46,8.84,17.39,7.86,48.28-3.78,61.74,1.62-6.93,6-14.69,7.56-23.1,1.16-1.7-1.47-.89-1.26-2.1.82-22.09-2.73-39.83-13.44-50.4,2.42,6.83,7,11.46,8.4,19.32-11.9-3.49-30.2-4.26-47.46-5-19.61-.89-44.5-.71-58,5.46-.73.34-1.93,1.34-2.94.84,3.26-14.39,11.14-26.38,18.48-35.28C186.82,13.91,208.63,16.35,231,14.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.62,47.94c-5,4.78-13.66,6.86-22.26,8.4-18.09,3.23-39.22,1.5-57.54-.42-9.32-1-19.17-.43-25.2-5.46,6.56-7,20.18-5.83,31.08-7.14,9-1.08,20.12,0,30.66.42C229.29,44.42,244.71,43.92,256.62,47.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.72,51.72c.66,11.83,3.28,22,0,31.92-1.87,5.65-9.49,14.06-14.7,17.64-17.14,11.81-50.4,17.62-65.93,1.26-.08-2.27-.21-1-1.69-1.68-4.45-2.16-9.07-12.87-13-17.64-.08,2,.85,3.06,1.67,4.2-3.39.94-5.29,3.38-8.4,4.62-2.06-4.46,4.34-6.18,6.3-9.24-3.11-.31-4.87,4.36-8,5.46-3.49-5.67,6-7.54,7.56-12.18-4.2-.25-6.38,5.07-10.07,6.72-3.93-6,3.71-8,5.46-12.18-2.48-.23-5.41,4.95-7.57,5C148.2,70.11,149.48,62,150,55.5a218.84,218.84,0,0,0,62.15,6.72c17.43-.81,35.28-2.76,45.78-10.5Zm-94.91,8.82c-.48.09-.66.47-.85.84.43,0,.51.34.85.42,8.56,6,26.17,6.3,42.41,6.3,10.89,0,21.45-.3,29.4-2.52,2.55-.71,5.67-1.34,6.72-3.36C220.23,67.67,184.08,67.06,163.81,60.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226,142c-4,8.37-13.26,15.33-26.46,11.76-2.15-3.3-4.39-6.52-5.88-10.5C203.5,145.73,217.52,145.59,226,142Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.59,142.44c1.17.22,2.18.61,3.36.84,0,3.06,2.05,4.1,2.51,6.72A31.92,31.92,0,0,1,188.59,142.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.14,155c.31-.75.77-.06,1.26,0,14.58,27.6,11.09,78,10.5,118-1-19.51-1.18-41-2.52-61.73C204,190.2,204.3,169.51,196.14,155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.76,157.56c5.11-.26,14.52,1,17.22-2.94.49-.07.75.09.84.42-7.13,15.55-6.62,38.74-8,60.06.12.75-.39.86-.42.42C210.57,192.83,208.88,172,200.76,157.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.26,255.84c1.42,1.93.67,7,.84,11.33.11,2.58,1.62,6.35-1.26,6.3C210.61,271,211.76,261.94,211.26,255.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.66,264.65c-.7.31-2.41,1.75-2.94.85C216.38,263.9,218.71,265,219.66,264.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.12,265.07c-2.1,2.38-5.73,3.23-8.4,5.05C218.1,267,222.31,266.74,225.12,265.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231,266.33c-3.7,2.88-8.92,4.24-12.18,7.57-.18-.38-.37-.76-.84-.85A49,49,0,0,1,231,266.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.46,268c-3.87,3.12-10.37,3.62-12.6,8.39a27.54,27.54,0,0,1-3.78-1.67C225.47,272.69,230.54,268.14,236.46,268Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.5,269.28c-1.46.63-2.46,1.74-4.62,1.67C238,270.11,239.45,267.85,241.5,269.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244,269.69c2.65,1,5.66,1.63,8,2.94-1.25,1.51-2.67,2.49-4.62,1.27.15-.56.74-.66.84-1.27-.15-.55-.73-.66-.84-1.26-2,.25-2.62,1.57-4.62.85C242.77,271,243.86,270.79,244,269.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.78,272.22c-3,1.74-5.27,4.24-9.24,5A22.54,22.54,0,0,1,234.78,272.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.5,273.9c-2.51,2.38-6.09,3.7-8.82,5.88-1.29-.11-1.89-.92-2.94-1.27C233.33,276.69,236.59,273.09,241.5,273.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257,275.57a6.1,6.1,0,0,1-4.62,2.94,1.81,1.81,0,0,0-.83-1.67C252.83,275,255.12,273.49,257,275.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.42,52.56c1.08,0,.6,1.64,1.68,1.68-2,7.18-1,18.15-.84,25.2,1.82,1.74,4.08,6.85,0,7.56C145.09,78,145.83,62.81,147.42,52.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.21,92.46C149.87,92,150,90,149.1,89.1,151.51,85,154.63,90.76,151.21,92.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.06,88.26a16.91,16.91,0,0,1,2.53,5c-2.81,1.25-4.14,4-7.14,5-.5-1.32-1.42-2.22-1.69-3.78A23.31,23.31,0,0,0,165.06,88.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155,93.3a3.16,3.16,0,0,1-2.51,2.52C150,93.91,154.19,89.69,155,93.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168,94.56c1.88.09,1.48,2.44,2.94,2.94-2.81,1.52-4.74,3.93-7.55,5.46-.25-.88-.89-1.36-1.27-2.1C163.12,97.79,166.93,97.55,168,94.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.24,96.66c1.51,1.26,3.42,5,0,5.46-.63-1.32-1.86-2.05-2.1-3.78A17.37,17.37,0,0,0,156.24,96.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.36,99.18c2,.13,1.7,2.5,3.36,2.94-2.12,2.49-5.22,4-7.13,6.72-1.13-.69-1.51-2.13-2.53-2.94C166.78,103.27,170.09,102.25,171.36,99.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160,102.54a4.22,4.22,0,0,0,1.26,2.52c-.54.72-.86,1.65-2.1,1.68C158.25,104.82,156.44,102.88,160,102.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.16,103c.56,7.17-8.58,15-14.7,20.16A230.7,230.7,0,0,1,251.16,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176,103.8c1.23.58,1.7,1.94,2.93,2.52-2.61,2.15-5.59,3.93-8,6.3a6,6,0,0,1-2.1-2.1C170.47,107.52,174,106.44,176,103.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.12,108c1.76.21,2,1.9,2.52,3.36-.37.19-.75.37-.83.84C162.19,111.69,160.4,109.38,162.12,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.76,108c2.24.14,2.73,2,4.62,2.52-2.53,2.65-5.63,4.72-8.39,7.14C168.77,114.29,178,111.79,179.76,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231,111.36c-4.34,6.3-11.32,13.59-17.22,19.74h-5c4.66-4.72,11-7.76,13.86-14.28-3.23,1.31-6,4-9.24,6.72-4.07,3.42-7.15,8.63-13.44,6.3,6.12-5.23,13.68-9,18.9-15.12A40.15,40.15,0,0,0,231,111.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.36,113.46c-3.5,3.08-7.45,5.71-10.91,8.82a5.68,5.68,0,0,1-3.78-2.94C182.59,116.89,185.47,109.15,192.36,113.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.49,112.62c2.22.48,3.36,3.45.41,3.78C165.26,115.17,163.9,113.8,165.49,112.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.18,115.14c-2.51.9-4.46,3.46-7.56,2.52-1.24,3.18-4.42,5.23-7.55,7.56-1.24.11-1.3-1-2.52-.84C189,121,192.65,112.93,201.18,115.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.88,115.14c-3.3,2.76-7.31,4.58-10.92,7.14-3.29,2.34-6.13,7-10.92,6.3,4.13-5,11.29-6.91,14.7-12.6-8.46,1.34-12.61,9.21-19.32,10.92,4.26-4.15,10.37-6.43,13.44-11.76C208.06,115.21,210.75,115.25,215.88,115.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173,120.6c-.26,1.14-1.75,1-1.68,2.52-1.12-1.54-2.68-2.64-3.36-4.62C169.91,115.8,171.67,119.17,173,120.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.3,122.28c1.16.8,2.21,1.71,3.37,2.52-.15,1.39-1.26,1.82-2.11,2.52-2-.13-1.69-2.5-3.36-2.94C172.83,123.61,174,123.33,174.3,122.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.28,128.16a13,13,0,0,1-2.94,2.94c-1.14-.26-1-1.76-2.52-1.68C178,127.33,180.32,126.24,182.28,128.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M186.07,130.26c-.76,1.77-2.6,3.71-4.62,2.94C182.11,131.34,183.67,130.39,186.07,130.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.9,136.14c-1.13,3.07-5.17,3.23-9.66,2.94C200.34,136.9,203.41,134.67,207.9,136.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.72,136.14c-1.83,1.25-4.71,1.44-7.14,2.1C210.36,135.93,213.5,136,216.72,136.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.94,94.56c-.34,3.35-3.71,5.23-5.88,7.56-6.46,6.95-12.28,15.9-17.64,24.36A34.76,34.76,0,0,0,224.7,129c2.79-4.94,7.71-8.57,11.76-13C242.77,109.06,248.53,101.59,254.94,94.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239,107.58c-5.79,7.09-13.48,15.91-20.58,23.1A148.61,148.61,0,0,1,239,107.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.22,135.3c1.43-2,3.58-4.07,6.31-2.52-.73,1.37-2.22,2-2.94,3.36,1.34,1.71,4-1.63,5.45-2.52,1.7.4,3.35.85,5.05,1.26-1.14,1.81-3.07,2.81-4.63,4.2A33.8,33.8,0,0,1,185.22,135.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247,276c-4.65,2.87-10.84,8-20.58,8.81-15.49,1.35-37.17-.81-51.24-2.52-6.45-.78-11.07-1.23-11.33-8,9.18-6.08,22.65-7.87,37.79-8-3.58,9-16.31,8.89-26.46,11.34,8.74,1.63,21.72.52,26.88-4.2,2,4.61,9.32,6.64,13.44,2.53,3.7,2.57,8.68,5.72,14.7,4.62,2,.66-2.53,1.5-2.1,3.35h.84c3.07-.94,6.51-3.18,9.66-5C241.19,277.39,244.24,274.69,247,276Zm-50,3.36c1.2,3.13,6,4.92,10.07,3.77C203.6,282.22,200,279.38,197,279.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.32,278.1c.22,2.87-3.75,1.56-5,2.93C245.41,280.17,248.06,278.22,250.32,278.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.12,283.55c19.48,11.13,61.38,10.14,88.2,5.05-13.55,7.45-34.8,7.89-55.44,5.45C180.74,292.39,169.05,291.23,162.12,283.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.201c087178d2707d16bd0d1a2da4be2f.svg";
export { ForwardRef as ReactComponent };